import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=3502a0ba&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3502a0ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3502a0ba')) {
      api.createRecord('3502a0ba', component.options)
    } else {
      api.reload('3502a0ba', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=3502a0ba&scoped=true", function () {
      api.rerender('3502a0ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintenance/service/edit.vue"
export default component.exports